import React, {useEffect} from 'react'
import {Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
import {useTranslation} from "react-i18next";


const UrbanClimateLayout = () =>{
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/urban-climate",
            type:"pageView"
        }))
    }, []);
    return(
        <React.Fragment>
            <Subtitle/>
            <br/>
            <br/>
            <Typography variant="h4" style={{fontWeight: "bold"}}>
                {t('urban_climate.title' as any)}
            </Typography>
            <br/>
            <Typography paragraph>
                {t('urban_climate.paragraph_1' as any)}
             </Typography>
            <Typography paragraph>
                {t('urban_climate.paragraph_2' as any)}
             </Typography>
            <Typography paragraph>
                {t('urban_climate.paragraph_3' as any)}
            </Typography>
            <Typography paragraph>
                {t('urban_climate.paragraph_4' as any)}
             </Typography>
        </React.Fragment>
    )

}
export default UrbanClimateLayout
